// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1534e23b","453":"9b90c8f3","455":"c11cf5bc","977":"81a2798d"}[chunkId] + ".chunk.js";
};